import { render, staticRenderFns } from "./PaymentRecipientModal.vue?vue&type=template&id=3797ca5e&scoped=true&"
import script from "./PaymentRecipientModal.vue?vue&type=script&lang=js&"
export * from "./PaymentRecipientModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRecipientModal.vue?vue&type=style&index=0&id=3797ca5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3797ca5e",
  null
  
)

export default component.exports